import React, {useState} from 'react';
import styles from './navigation.module.scss';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/Menu';
import {makeStyles} from "@material-ui/core/styles";
import DrawerMenu from "./DrawerMenu/DrawerMenu";

const useStyles = makeStyles({
    menu: {
        color: '#fff',
        fontSize: '55px',
        marginLeft:'3vw'
    },
    menuButton: {
        position: 'absolute',
        right: '4vw',
    }

});

function Navigation() {

    const classes = useStyles();
    const [menuState,setMenuState]=useState(false)
    const handleMenu=()=>{
       setMenuState(true)
        console.log(menuState)
    }

    return (
        <div>
            <AppBar>
                <Toolbar className={styles.container}>
                    <Typography variant={"h3"}>
                        Vr Logo
                    </Typography>
                    <Box className={classes.menuButton}>
                        <Button>contact us</Button>
                        <IconButton onClick={handleMenu}>
                            <MenuIcon className={classes.menu}/>
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="top"
                open={menuState}
                onClose={()=>{setMenuState(false)}}
            >
                <DrawerMenu setMenuState={setMenuState}/>
            </Drawer>
        </div>
    );
}

export default Navigation;
